var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-md-preview',{attrs:{"text":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }